import { Text } from '@chakra-ui/react'

import { colors } from '../../theme/cssVariables'
import { getRarityColorMap, rarityType } from '../../constants/skinPropertes'
import { TopDrop } from '../../types/lucksterEvent'
import { getSkinDisplayRarity } from '../../utils/getSkinDisplayRarity'

import PrizeBox from '../PrizeBox'
import { useFormatSkinName } from '../../hooks/useFormatName'

const Front = (props: TopDrop) => {
  const formatSkinName_ = useFormatSkinName()
  const displayRarity = getSkinDisplayRarity(props?.rarity, props?.name)
  // const rarity = getRarityColorMap(displayRarity as unknown as rarityType)
  const nameStrs = formatSkinName_(props.name)?.split('|')
  const isMobile = props.isMobile
  return (
    <PrizeBox
      rarity={displayRarity as unknown as rarityType}
      imageUrl={props.imageUrl}
      name={nameStrs?.[0]}
      isMobile={isMobile}
    >
      <Text
        color={colors.colorB1}
        fontSize={['8px', '11px']}
        left={'7px'}
        overflow={'hidden'}
        position="absolute"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        width="90%"
        bottom={['15px', '19px']}
        opacity={0.5}
      >
        {nameStrs?.[0]}
        {/* {specialtyEnum[_.prize.otherAttrs?.base?.specialty as keyof typeof specialtyEnum]} */}
      </Text>
      <Text
        color={colors.colorB1}
        fontSize={['8px', '11px']}
        left={'7px'}
        overflow={'hidden'}
        position="absolute"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        width="90%"
        bottom={['6px', '5px']}
        fontWeight={600}
      >
        {nameStrs?.[1]}
        {/* <Trans>{phaseEnum[_.prize.otherAttrs?.base?.phase as keyof typeof phaseEnum]}</Trans> */}
      </Text>
    </PrizeBox>
  )
}

export default Front
